import ContactForm from "./contactForm";
import ContactMap from "./contactMap";
export default function ContactUs(){
    return (
        <div id="contact" className="contact-us container">
            <div className="row">
            <ContactForm/>
            <ContactMap/>
            </div>
      </div>
       
    )
}